/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-13 11:51:25
 */
const parentRouter = [
  {
    label: '系统管理',
    path: ''
  }
]
const routes = [
  {
    path: '/system/user',
    name: 'user',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '用户管理',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/system/views/User.vue')
  },
  {
    path: '/system/user/userAuth',
    name: 'userAuth',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '用户权限',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '用户管理', path: '/system/user' }]
    },
    component: () => import('@main/modules/system/components/userView.vue')
  },
  {
    path: '/system/user/profile',
    name: 'userProfile',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '个人中心',
      keepAlive: false
    },
    component: () => import('@main/modules/system/components/userProfile.vue')
  },
  {
    path: '/system/dict',
    name: 'Dict',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '字典管理',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/system/views/dict.vue')
  },
  {
    path: '/system/dict/dictValue',
    name: 'DictValue',
    meta: {
      icon: 'icon-renyuanguanli',
      title: '字段值管理',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '字典管理', path: '/system/dict' }]
      // parentTitle: ['系统管理', '字典管理']
    },
    component: () => import('@main/modules/system/views/dictValue.vue')
  }
]
export default routes
